/* eslint-disable @typescript-eslint/no-unused-vars */
import styles from './UpdatePaymentPage.module.scss';
import { LoadingOverlay } from 'src/pages/PaymentBetaPage/components/LoadingOverlay';
import {
  useBreakpoint,
  useGetUser,
  useLogout,
  useSubscriptionPlanById,
  useTeamInfo,
  useVisible,
} from 'src/hooks';
import { useState } from 'react';
import { UpgradeForm } from 'src/pages/PaymentBetaPage/components/UpgradeForm';
import { CanonicalInterval } from 'src/types';
import { Warning } from '@phosphor-icons/react';
import { AVAILABLE_FEATURES_LIST, SVG_SIZE_M, SVG_SIZE_S } from 'src/constants';
import { NinjaAgentsOutlinedIcon } from 'src/images/icons/ninjaAgentsOutlined';
import { CheckoutUpdatePaymentMethod } from 'src/pages/UpdatePaymentPage/components/CheckoutUpdatePaymentMethod';
import { Modal } from 'src/components/Modal';
import { Button } from 'src/v2/commonComponents/Button';
import { PeriodSwitch } from 'src/components/PeriodSwitch';
import { PlanCard } from 'src/pages/PaymentBetaPage/components/PlanCard';
import { convertTierName } from 'src/utils/user';

// TODO: WIP
export const UpdatePaymentPage = () => {
  const { tier_id, isTeamsMaxTier } = useGetUser();
  const { teamInfo, isTeamInfoLoading } = useTeamInfo();
  const { isMobile } = useBreakpoint();
  const { logout } = useLogout();

  const [selectedPeriod, setSelectedPeriod] = useState<CanonicalInterval>(
    CanonicalInterval.MONTHLY,
  );

  const isNewPlanPage = AVAILABLE_FEATURES_LIST.newSuperNinjaPlans;

  const currentPlanName = (tier_id || '').replaceAll('_', '-');

  const currentType = isTeamsMaxTier ? 'Teams_SuperNinja_Ultra' : 'Teams_Ultra';

  const { isVisible, onVisibilitySet, onVisibilityRemove } = useVisible(true);

  const [isPaymentProcessing, setPaymentProcessing] = useState<boolean>(false);

  const numberOfSeats = teamInfo?.num_seats_total || 0;

  const { plan: currentPlan, isPlanLoading } = useSubscriptionPlanById({
    plan_id: `${currentPlanName}-${selectedPeriod}`,
    seat_count: numberOfSeats,
    shouldSkip: !teamInfo || isTeamInfoLoading || numberOfSeats === 0,
    withoutReferral: true,
  });

  const convertedPlanName = convertTierName(tier_id || '') || '';

  const handleCloseRightSidePanel = () => {
    onVisibilitySet();
  };

  const handleCancelSubscription = () => {
    logout();
  };

  const bannerComponent = (
    <div className={styles.topBanner}>
      <Warning weight="fill" size={SVG_SIZE_M} className={styles.warningIcon} />
      <span>
        Update your payment method to continue using {convertedPlanName} plan
      </span>
    </div>
  );

  return (
    <div className={styles.root}>
      {(isPlanLoading || isTeamInfoLoading || isPaymentProcessing) && (
        <LoadingOverlay
          label={
            isPaymentProcessing ? 'Verifying payment...' : 'Loading plans...'
          }
        />
      )}
      <div className={styles.leftSideSection}>
        {bannerComponent}
        <div className={styles.periodSwitchWrapper}>
          {/* <PeriodSwitch
            selectedPeriod={selectedPeriod}
            onChangePeriod={setSelectedPeriod}
            isTeams={true}
          /> */}
        </div>
        <div className={styles.planCardWrapper}>
          <div className="nj-plan-section nj-plan-section--teams">
            {isNewPlanPage ? (
              <></>
            ) : (
              // <PlanCard
              //   period={selectedPeriod}
              //   type={currentType}
              //   isSelected={true}
              //   selectedPlan={currentPlan}
              //   isTeams={true}
              // />
              <UpgradeForm
                period={selectedPeriod}
                type={currentType}
                isTeams={true}
                isSelected={true}
                selectedPlan={currentPlan}
              />
            )}
          </div>
        </div>
        <div className={styles.hints}>
          <div className={styles.hintRow}>
            <span className={styles.icon}>*</span>
            <span>
              Subject to abuse thresholds. High volume usage may slow down the
              processing of your request
            </span>
          </div>
          <div className={styles.hintRow}>
            <NinjaAgentsOutlinedIcon width={SVG_SIZE_S} height={SVG_SIZE_S} />
            <span>
              Ninja LLM: Fine-tuned and powered by Ninja’s infrastructure
            </span>
          </div>
          <div className={styles.buyWithAwsFooter}>
            Available in AWS Marketplace
          </div>
        </div>
      </div>
      <div className={styles.rightSideSection}>
        {isMobile && bannerComponent}
        <CheckoutUpdatePaymentMethod
          onClose={handleCloseRightSidePanel}
          onPaymentProcessing={setPaymentProcessing}
          currentPlan={currentPlan}
        />
      </div>
      <Modal
        open={isVisible}
        onClose={onVisibilityRemove}
        closeOnOverlayClick={false}
        showCloseIcon={false}
        overlayClassName={styles.overlay}
        className={styles.modal}
      >
        <div className={styles.modalContent}>
          <h3 className={styles.title}>Payment declined</h3>
          <span className={styles.description}>
            We couldn't process your payment. Please update your payment method
            to continue using {convertedPlanName} plan. You have{' '}
            <b>180 days to renew</b> your subscription.
          </span>
          <div className={styles.buttonRow}>
            <Button onClick={handleCancelSubscription} color="link">
              Sign out
              {/*Cancel subscription*/}
            </Button>
            <Button onClick={onVisibilityRemove}>Update Payment</Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
